import { render } from "./Deals.vue?vue&type=template&id=0fcc6cb2&scoped=true"
import script from "./Deals.vue?vue&type=script&lang=js"
export * from "./Deals.vue?vue&type=script&lang=js"

import "./Deals.vue?vue&type=style&index=0&id=0fcc6cb2&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcc6cb2"]])

export default __exports__